/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Enhance_ModeInputs */

const cs_property_ai_enhance_mode = /** @type {(inputs: Property_Ai_Enhance_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Režim vylepšení`)
};

const en_property_ai_enhance_mode = /** @type {(inputs: Property_Ai_Enhance_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enhance mode`)
};

/**
* | output |
* | --- |
* | "Enhance mode" |
*
* @param {Property_Ai_Enhance_ModeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_enhance_mode = /** @type {((inputs?: Property_Ai_Enhance_ModeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Enhance_ModeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_enhance_mode(inputs)
	return cs_property_ai_enhance_mode(inputs)
});